import { Box, Grid, Typography } from '@material-ui/core'
import styled, { css } from 'styled-components'

export const PrivateJobContainer = styled(Box)`
  max-width: 80em;
  margin: 1rem auto;

  .MuiGrid-spacing-xs-2 {
    margin: 0;
  }
`

export const PrivateJobHeader = styled(Box)<{ isDevice: boolean }>`
  width: 100%;
  margin: ${({ isDevice }) => (isDevice ? '1rem auto 0' : '1.5rem auto 1rem')};
  padding: 0 0.6rem;
  gap: 1rem;
`

export const PrivateJobMain = styled(Grid)`
  && {
    width: 100%;
    overflow-x: hidden;
  }

  @media (max-width: 400px) {
    && {
      padding: 0.6rem;
    }
  }
`
export const PrivateJobTitle = styled(Typography)`
  && {
    font-weight: 900;
    font-size: 1.3rem;
    color: ${({ theme }) => theme.colors.accent1};
  }
`

export const PrivateJobTitleInner = styled.span`
  display: inline-flex;
  align-items: center;

  :hover {
    cursor: pointer;
  }
`

export const PrivateJobLeftContainer = styled(Box)<{ isDevice?: boolean }>`
  flex: 2;
`
export const PrivateJobMiddleContainer = styled(Box)`
  flex: 2;
  height: 100%;
  overflow: hidden;
`

export const PrivateJobRightContainer = styled(Box)`
  flex: 0.5;
  display: flex;
  justify-content: flex-end;
  height: 100%;

  @media (max-width: 500px) {
    && {
      padding: 0;
    }
  }
`
export const StyledJobSearchButton = styled(Box)`
  & {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`